type localesKeys__RightSwitcher = {
  MiniCvLabel: string;
  SkillsLabel: string;
}

const ruLocale__RightSwitcher: localesKeys__RightSwitcher = {
    MiniCvLabel: 'Микро резюме',
    SkillsLabel: 'Общие навыки'   
};

const enLocale__RightSwitcher: localesKeys__RightSwitcher = {
  MiniCvLabel: 'Micro CV',
  SkillsLabel: 'General Skills'
};

export { ruLocale__RightSwitcher, enLocale__RightSwitcher };
export type { localesKeys__RightSwitcher };